import Box from "../../../kit/Box";
import { DetailsHeadings } from "../../../theme/commonElements";
import InfoToolTip from "../../../components/MUIComponents/InfoToolTip";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalRapid from "./ModalRapid";
import { useSelector } from "react-redux";
import CustomMultiAutocompleteRapid from "../Component/CustomMultiAutocompleteRapid";
import {
  updateRapidDetailsData,
  updateTotalCostData,
} from "../../../redux/slice/dataSlice";
import { useDispatch } from "react-redux";
import { useTheme } from "@emotion/react";
import { useStyles } from "../../../theme/style";
import EditableRapidFooter from "./EditableRapidFooter";
import { updateAlertInfo } from "../../../redux/slice/userSlice";
import MUITextField from "@mui/material/TextField";
import {
  checkAppUrlUnique,
  submitRapidApplicationRequest,
} from "../../../services/api";
import Modal from "../../../components/Modal/Modal";
import OktaUserMultiSelect from "../Component/Inputs/OktaUserMultiSelect";
import { CircularProgress, Grid } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import APP_CONSTANTS from "../../../utils/config";
import { getDevEnvironment, getTotalCost } from "../../../utils/utils";
import { MultiSelectChipCard } from "../../../kit/MultiselectChipCard";

const EditableDetailsPage = ({ isRegistering, userEmail, register_id, handleNext }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const classes = useStyles(theme);
  const infraDataJson = useSelector((state) => state.data.rapidData?.infraJson);
  const detailsJson = useSelector((state) => state.data.rapidData?.detailsJson);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const [applicationNameState, setApplicationNameState] = useState({
    loader: false,
    success: false,
    failed: false,
  });

  const [buttonState, setButtonState] = useState({
    back: true,
    submit: false,
    next: false,
    modalSubmit: false,
    saveAsDraft: false,
  });

  const [disablePage, setDisablePage] = useState(true);
  const [errorText, setErrorText] = useState("");
  const [applicationName, setApplicationName] = useState({ id: "", value: "" });
  const appStatus =
    useSelector((state) => state.data.rapidData?.current_status) || "";
  const copyToClipboard = ({}) => {
    navigator.clipboard
      .writeText(register_id)
      .then(() => {
        dispatch(
          updateAlertInfo({
            message: "Copied",
            open: true,
            severity: "success",
          })
        );
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  const commonHandleChange = (id, category_id, value) => {
    const updatedData = detailsJson.map((item, index) => {
      if (index !== 3) {
        return {
          ...item,
          resources: item.resources?.map((resource) => {
            if (resource.resource_id === id) {
              return { ...resource, value };
            }
            return resource;
          }),
        };
      }
      return item;
    });
    dispatch(updateRapidDetailsData(updatedData));
  };
  const handleBack = () => {
    navigate("/rapid");
  };
  const handleSubmit = () => {
    setIsModalOpen(true);
  };
  const handleSubmitForTechnicalOwner = () => {
    setShowPopup(true);
    setIsModalOpen(false);
    // navigate('/rapid')
  };
  const handlePopupConfirm = async () => {
    setShowPopup(false);
    await submitApplicationRequest();
  };
  const submitApplicationRequest = async () => {
    const payload = {
      infra_details: infraDataJson,
      details: detailsJson,
      status: "",
      request_id: register_id || "",
    };
    try {
      const resp = await submitRapidApplicationRequest({
        payload: payload,
      });

      const statusCode = resp?.data?.status?.statusCode;
      const message = resp?.data?.status?.statusMessage;
      if (statusCode === 200) {
        navigate("/rapid");
      } else {
        dispatch(
          updateAlertInfo({
            message: message,
            open: true,
            severity: "error",
          })
        );
      }
    } catch (err) {
      console.error("Error", err);
    }
  };
  const handleChangeApplicationName = (id, category_id, value) => {
    const regex = /^[a-zA-Z0-9]*$/;
    if (regex.test(value) && value.length <= 15) {
      setErrorText("");
      setApplicationNameState((prev) => ({
        ...prev,
        success: false,
        loader: true,
      }));
      setApplicationName({
        id: id,
        value: value,
      });
    } else {
      if (value.length > 15) {
        dispatch(
          updateAlertInfo({
            message: "Limit of 15 characters Reached",
            open: true,
            severity: "error",
          })
        );
        // setErrorText("The value cannot exceed 15 characters!");
      }
    }
  };

  const getStatusIcon = (fieldState) => {
    if (fieldState?.loader) {
      return (
        <CircularProgress size={20} sx={{ marginLeft: "8px", color: "red" }} />
      );
    }
    if (fieldState?.success && !fieldState?.loader) {
      return (
        <CheckCircleIcon
          sx={{ marginLeft: "8px", color: "green", fontSize: 20 }}
        />
      );
    }
    if (fieldState?.failed && !fieldState?.loader) {
      return (
        <CancelIcon sx={{ marginLeft: "8px", color: "red", fontSize: 20 }} />
      );
    }
    return null;
  };

  // taking application state from the Redux Store.
  useEffect(() => {
    const appResource = detailsJson[0]?.resources?.find(
      (resource) => resource.resource_name === "Application Name"
    );
    if (appResource) {
      setApplicationName({
        id: appResource.resource_id,
        value: appResource.value,
      });
    }
    // Set page disabled state based on isRegistering prop
    setDisablePage(!isRegistering);
    const enviromant = getDevEnvironment(infraDataJson);
    const cost = getTotalCost(
      infraDataJson,
      enviromant?.dev,
      enviromant?.uat,
      enviromant?.prod
    );
    dispatch(updateTotalCostData(cost));
  }, [isRegistering]);

  useEffect(() => {
    commonHandleChange(applicationName.id, 0, applicationName.value);
    if (applicationName.value == "") {
      setErrorText("");
      setApplicationNameState({
        loader: false,
        success: false,
        failed: false,
      });
    } else {
      const debounceTimer = setTimeout(() => {
        const fetchStatus = async () => {
          try {
            const resp = await checkAppUrlUnique({
              payload: {
                application_name: applicationName.value,
                request_id: register_id || "",
              },
            });

            const statusCode = resp?.data?.status?.statusCode;
            const message = resp?.data?.status?.statusMessage;
            if (statusCode === 200) {
              const response_data = resp?.data?.data;
              if (response_data?.isValid) {
                setErrorText("");
                setApplicationNameState((prev) => ({
                  ...prev,
                  loader: false,
                  success: true,
                  failed: false,
                }));
              } else {
                const regex = /[A-Z]/;
                if (regex.test(applicationName.value)) {
                  setErrorText(
                    "The entered value cannot contain capital letters."
                  );
                } else {
                  setErrorText("The entered value is not valid.");
                }
                setApplicationNameState((prev) => ({
                  ...prev,
                  loader: false,
                  success: false,
                  failed: true,
                }));
              }
            } else {
              dispatch(
                updateAlertInfo({
                  message: message,
                  open: true,
                  severity: "error",
                })
              );
              setErrorText("The entered value is not valid.");
              setApplicationNameState((prev) => ({
                ...prev,
                loader: false,
                success: false,
                failed: true,
              }));
            }
          } catch (err) {
            setErrorText("The entered value is not valid.");
            setApplicationNameState((prev) => ({
              ...prev,
              loader: false,
              success: false,
              failed: true,
            }));
            console.error("Error", err);
          }
        };
        !disablePage && fetchStatus();
      }, 500);
      return () => clearTimeout(debounceTimer);
    }
  }, [applicationName]);

  // Effect for Validation check
  useEffect(() => {
    let isSubmitButton = true;
    let isNextButton = true;
    let isModalSubmitButton = true;
    
    // If not registering (view mode), enable navigation buttons
    if (!isRegistering) {
      setButtonState((prev) => ({
        ...prev,
        submit: false, // Disable submit in view mode
        next: true,    // Enable next button
        modalSubmit: false, // Disable modal submit in view mode
        saveAsDraft: false, // Disable save as draft in view mode
      }));
      return;
    }
    
    outerLoop: for (let i = 0; i < detailsJson.length - 1; i++) {
      const category = detailsJson[i];
      for (let j = 0; j < category?.resources?.length; j++) {
        const resource = category?.resources[j];
        if (
          resource?.isRequired &&
          (!resource.value ||
            resource.value.length === 0 ||
            applicationNameState?.failed)
        ) {
          isNextButton = false;
          isSubmitButton = false;
          break outerLoop; // Breaks out of both loops
        }
      }
    }
    if (isNextButton && !disablePage) {
      const category = detailsJson[3] || {};
      for (let j = 0; j < category?.resources?.length; j++) {
        const resource = category?.resources[j];
        if (!resource.value || resource.value.length === 0) {
          isModalSubmitButton = false;
          break;
        }
      }
    }
    setButtonState((prev) => ({
      ...prev,
      submit: isSubmitButton,
      next: isNextButton,
      modalSubmit: isModalSubmitButton,
    }));
    if (applicationNameState.success) {
      setButtonState((prev) => ({
        ...prev,
        saveAsDraft: true,
      }));
    }
  }, [detailsJson, applicationNameState, isRegistering]);

  return (
    <>
      {/* To show request id on top */}
      {!isRegistering && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: theme.size[8],
          }}
        >
          <div
            style={{
              marginBottom: theme.size[12],
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: theme.size[14],
                fontWeight: theme.fontWeight[500],
              }}
            >
              Request ID: {register_id}
            </Typography>
            <ContentCopyIcon
              sx={{
                marginLeft: theme.size[8],
                fontSize: theme.size[18],
                color: theme.palette.secondary.main,
                cursor: "pointer",
              }}
              onClick={copyToClipboard}
            />
          </div>
        </div>
      )}
      <Box id="editable"
        sx={{
          display: "flex",
          flexDirection: "column",
          // margin: "15px",
          height: "calc(93% - 70px)",
          overflow: "auto",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gridGap: "25px",
            marginBottom: "15px",
          }}
        >
          {detailsJson[0]?.resources?.map((resource, index) => (
            <Box sx={{ width: "100%" }} key={index}>
              <DetailsHeadings display="flex">
                {resource.resource_name}{" "}
                {resource.isRequired && (
                  <span className={""} style={{ color: "red", marginLeft: 5 }}>
                    *
                  </span>
                )}
                <InfoToolTip
                  theme={theme}
                  title={resource.info || resource.resource_name}
                />
              </DetailsHeadings>
              <Box
                sx={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <MUITextField
                  multiline
                  value={
                    resource.resource_name === "Application Name"
                      ? applicationName.value
                      : resource.value || ""
                  }
                  placeholder={resource.placeholder}
                  disabled={resource.disabled || disablePage}
                  error={resource.hasError} // Use an error state to toggle error
                  helperText={
                    resource.resource_name === "Application Name"
                      ? errorText
                      : ""
                  } //{resource.hasError ? resource.errorMessage || "Invalid value" : ""}
                  FormHelperTextProps={{
                    sx: { color: "red" }, // Set the color of the helper text to red
                  }}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (resource.resource_name === "Application Name") {
                      handleChangeApplicationName(
                        resource.resource_id,
                        index,
                        inputValue
                      );
                    } else {
                      commonHandleChange(
                        resource.resource_id,
                        index,
                        inputValue
                      );
                    }
                  }}
                  sx={{
                    flexGrow: 1, // Allows the text field to take up remaining space
                    "& .MuiOutlinedInput-root": {
                      padding: `${theme.size[6]} ${theme.size[10]}`, // Adjusted padding
                      fontSize: theme.size[13],
                      color: theme.palette.form.text,
                      backgroundColor: theme.palette.form.fieldBackground,
                    },
                    "& .MuiOutlinedInput-input": {
                      // height: "auto", // Allow height to adjust based on content
                      height: resource.resource_name.includes("Description")
                        ? "60px !important"
                        : "20px !important",
                    },
                    "&.MuiTextField-root": {
                      backgroundColor: theme.palette.grey[4],
                      width: "100%",
                      borderRadius: theme.size[4],
                      fontFamily: theme.typography.fontFamily,
                      "&:hover": {
                        borderColor: "transparent",
                      },
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "transparent !important",
                    },
                  }}
                />
                {resource.resource_name === "Application Name" && (
                  <Box sx={{ marginLeft: "8px" }}>
                    {getStatusIcon(applicationNameState)}
                  </Box>
                )}
              </Box>
            </Box>
          ))}
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gridGap: "20px",
            marginBottom: "20px",
            marginLeft: "-5px",
          }}
        >
          {detailsJson[1]?.resources.map((resource, index) => (
            <Box margin={"5px"} key={index}>
              <DetailsHeadings display="flex">
                {resource.resource_name}
                {resource.isRequired && (
                  <span className={""} style={{ color: "red", marginLeft: 5 }}>
                    *
                  </span>
                )}
                <InfoToolTip
                  theme={theme}
                  title={resource.info || resource.resource_name}
                />
              </DetailsHeadings>
              {!(resource.disabled || disablePage) && (
                <CustomMultiAutocompleteRapid
                  options={resource.options.map((option) => option.description)}
                  value={resource.value || []}
                  id={resource.resource_id}
                  handleChange={(id, value, c) => {
                    commonHandleChange(id, index, value);
                  }}
                  keyField={resource.resource_id}
                  placeholder={resource.placeholder}
                  readOnly={resource.disabled || disablePage}
                />
              )}
              <Grid
                container
                spacing={resource.disabled || disablePage ? 0 : 1}
                // rowSpacing={1}
                // columnSpacing={1}
                // spacing={1}
                sx={{
                  marginTop: theme.size[0],
                  maxHeight: "100px",
                  overflowY: "auto",
                }}
              >
                {(resource.value || [])?.map((option, index) => {
                  return (
                    <MultiSelectChipCard
                      key={index}
                      chipValue={option}
                      theme={theme}
                      isDisabled={resource.disabled || disablePage}
                      handleChange={(chipValue, value) => {
                        const newValue = value.filter(
                          (item) => item !== chipValue
                        );
                        commonHandleChange(
                          resource.resource_id,
                          "multiple",
                          newValue
                        );
                      }}
                      value={resource.value || []}
                    />
                  );
                })}
              </Grid>
            </Box>
          ))}
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(1, 1fr)",
            gridGap: "5px",
          }}
        >
          {detailsJson[2]?.resources.map((resource, index) => (
            <OktaUserMultiSelect
              label={resource.resource_name}
              type="multi-select-dropdown"
              value={resource.value || []}
              placeholder="Select"
              options={[]}
              isRequired={resource.isRequired || false}
              info={resource.info || resource.resource_name}
              isDisabled={resource.disabled || disablePage}
              prefix=""
              componentId={index}
              categoryId={resource.resource_id}
              onChange={commonHandleChange}
              isOktaUserEnabled={true}
              disableInputSelection={disablePage}
              loggedInUserEmail={userEmail}
              componentUsed="Details"
            />
          ))}
        </div>
      </Box>

      <EditableRapidFooter
        handleBack={handleBack}
        handleNext={handleNext}
        handleSubmit={handleSubmit}
        buttonState={buttonState}
        register_id={register_id}
      />

      {showPopup && (
        <Modal
          headerMessage="Are you sure you want to Submit the Application?"
          cancelButtonText="Cancel"
          submitButtonText="Submit"
          onCancel={() => setShowPopup(false)}
          handleSubmit={handlePopupConfirm}
        />
      )}

      <ModalRapid
        headerMessage={"Add Technical Owner"}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        cancelButtonText="No"
        submitButtonText="Submit"
        handleSubmit={handleSubmitForTechnicalOwner}
        buttonState={buttonState}
        isRegistering={isRegistering}
        userEmail={userEmail}
      />
    </>
  );
};

export default EditableDetailsPage;
